import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { SourcesService } from './sourcesApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';

const initialState: any = {
    sourcesAreLoading: false,
    sourceIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchSources = createAsyncThunk<any, IPaginationPayload>(
    'sources/tryToFetchSources',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await SourcesService.tryToFetchSources(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchSourcesStats = createAsyncThunk<any, any>(
    'sources/tryToFetchSourcesStats',
    async (type) => {
        const result = await SourcesService.tryToFetchSourcesStats(type);

        return result?.data;
    },
);

export const sourcesSlice = createSlice({
    name: 'sources',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchSources
            .addCase(tryToFetchSources.pending, (state) => {
                state.sourcesAreLoading = true;
            })
            .addCase(tryToFetchSources.rejected, (state) => {
                state.sourcesAreLoading = false;
            })
            .addCase(tryToFetchSources.fulfilled, (state, action) => {
                state.sourcesAreLoading = false;
                state.sources = action.payload;
            })

            // tryToFetchSources
            .addCase(tryToFetchSourcesStats.pending, (state) => {
                state.sourcesAreLoading = true;
            })
            .addCase(tryToFetchSourcesStats.rejected, (state) => {
                state.sourcesAreLoading = false;
            })
            .addCase(tryToFetchSourcesStats.fulfilled, (state, action) => {
                state.sourcesAreLoading = false;
                state.sourcesStats = action.payload
            });
    },
});

export default sourcesSlice.reducer;
